import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './index.css';
import App from './pages/App';
import { supabase } from './lib/supabaseClient';
import { initPostHog, identifyUser, resetUser } from './lib/posthog';

// const root = ReactDOM.createRoot(document.getElementById('root'));
// root.render(
//   <React.StrictMode>
//     <App />
//   </React.StrictMode>
// );

// const container = document.getElementById('root') || document.getElementById('admin-root');

// console.log('🐞 mounting into:', container);

// if (!container) {
//   throw new Error('Could not find a mount node (tried #root and #admin-root)');
// }

const container = document.getElementById('root');

if (!container) {
  throw new Error('Could not find a mount node with ID "root"');
}

// Remove auth tokens from the URL hash after Supabase processes them
const removeAuthHash = () => {
  if (typeof window === 'undefined') return;
  const hash = window.location.hash || '';
  if (!hash) return;
  if (
    hash.includes('access_token') ||
    hash.includes('refresh_token') ||
    hash.includes('token_type') ||
    hash.includes('expires_in') ||
    /(^|#|&)type=/.test(hash)
  ) {
    const url = new URL(window.location.href);
    url.hash = '';
    window.history.replaceState({}, document.title, url.pathname + url.search);
  }
};
// Initialize PostHog analytics
initPostHog();

// Handle user identification for PostHog
const handleAuthStateChange = async (event, session) => {
  removeAuthHash();
  
  if (session?.user) {
    // User is logged in - identify them in PostHog
    identifyUser(session.user.id, {
      email: session.user.email,
      // Add any other user properties you want to track
      created_at: session.user.created_at,
    });
  } else {
    // User is logged out - reset PostHog identification
    resetUser();
  }
};

// Ensure cleanup on initial load and on any auth state change
supabase.auth.getSession().then(({ data: { session } }) => {
  if (session?.user) {
    identifyUser(session.user.id, {
      email: session.user.email,
      created_at: session.user.created_at,
    });
  }
}).finally(removeAuthHash);

supabase.auth.onAuthStateChange(handleAuthStateChange);

const root = createRoot(container);
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);